import React, { useEffect } from 'react';
import { Loading } from 'components';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { URL_LOGIN_3G } from 'global/environment';
import { UserService } from 'services/UserService';
import { CommonService } from 'services/CommonService';
import { LogService } from 'services/LogService';

const baseURL = process.env.REACT_APP_BACKEND_URL;

const Ads = () => {
  const authorized = useSelector(state => state.authorizedReducer.authorized);
  const isLogin3G = useSelector(state => state.authorizedReducer.isLogin3G);
  const history = useHistory();

  useEffect(() => {
    if (!authorized && !isLogin3G) {
      window.location.href = `${URL_LOGIN_3G}${history.location.pathname}${history.location.search}`;
      return;
    }
    const url = new URL(window.location.href);
    sessionStorage.setItem("shortLink", url.href);

    const act = url.searchParams.get("a");
    if (act.includes("v5G0K")) {
      sessionStorage.setItem("channel", "ckd");
      const sub_id = act.split('v5G0K')[1] || '';
      const urlRediect = `/dich-vu/goi-cuoc-di-dong${sub_id ? '?sub_id=' + sub_id : ''}`;
      shortLinkLog('ckd', '', sub_id, `${baseURL}${urlRediect}`, 'goicuocdidong');
      history.push(urlRediect);
    } else {
      getUrlMapping();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getUrlMapping = () => {
    const url = new URL(window.location.href);
    const act = url.searchParams.get("a");
    const short_link = `${url.origin}${url.pathname}?a=${act}`;
    const data = { short_link };

    UserService.getUrlMapping(data, res => {
      if (res.error_code === "0") {
        sessionStorage.setItem("channel", res.channel);
        sessionStorage.setItem("camp", res.camp);
        shortLinkLog(res.channel, res.camp, res.sub_id, `${baseURL}${res.convertUrl}`, res.action);
        history.push(res.convertUrl);
      } else {
        history.push('/dich-vu/goi-cuoc-di-dong');
      }
    })
  }

  const shortLinkLog = (pr_channel, campaign_code, package_id, urlredirect, action) => {
    const url = new URL(window.location.href);
    const ushortkey = url.searchParams.get("a");
    const result = CommonService.findGetParameter();
    delete result['a'];

    const user_agent = navigator.userAgent;
    const user_ip = '';
    const user_network = '';
    const user_id = '';
    const os = '';
    const referer = '';
    const device_id = '';

    const param = {
      ...result,
      mobile: result.m || '',
      pr_channel,
      campaign_code,
      package_id,
      action,
      urlredirect,
      ushortkey,
      campaign_content: '',
      campaign_desc: '',
      service: 'MYVNPT',
      user_agent,
      user_ip,
      user_network,
      os,
      user_id,
      clicktime: Date.now(),
      referer,
      device_id
    }

    LogService.shortLinkLog(param);
  }

  return (
    <Loading />
  );
}

export default React.memo(Ads);
